import {CreateTariffPlans} from './create-tariff-plans';

export default CreateTariffPlans;